import { CheckboxFormik } from "@starrez/starryui";
import * as React from "react";
import { IAttachmentListProps } from ".";
import { FileProcessingStatus } from "..";
import { strings } from "../../../../localisation";
import { ISendEmailDataModel } from "../../../EmailWizard/models/SendEmail";
import { SendEmailExecuteModel } from "../../../EmailWizard/models/SendEmail/SendEmailExecuteModel";

import { AttachmentListItems } from "../AttachmentListItems";
import { AttachmentListButton, AttachmentListWrapper } from "./AttachmentList.styles";

export const AttachmentList = ({ Attachments, OnAddAttachment, OnRemoveAttachment, Visible, FormikProps }: IAttachmentListProps) => {

    const [shouldAnimate, setShouldAnimate] = React.useState(false);
    const attachmentsUploading = Attachments.filter((att) => att.ProcessingStatus === FileProcessingStatus.Uploading);
    const attachmentsDeleting = Attachments.filter((att) => att.ProcessingStatus === FileProcessingStatus.Deleting);

    const attachmentButtonText = () => {
        let buttonText = strings.Action_Attachments_Add;

        if (attachmentsUploading.length) {
            buttonText = strings.Message_Attachment_Uploading;
        } else if (attachmentsDeleting.length) {
            buttonText = strings.Message_Attachment_Deleting;
        }

        return buttonText;
    };

    const onAttachmentListAnimatedEnd = () => {
        if (!Visible) {
            setShouldAnimate(false);
        }
    };

    React.useLayoutEffect(() => {
        if (Visible) {
            setShouldAnimate(true);
        }
    }, [Visible]);

    if (Attachments.length) {
        return (
            <AttachmentListWrapper
                Visible={Visible}
                ShouldAnimate={shouldAnimate}
                onAnimationEnd={onAttachmentListAnimatedEnd}
            >
                <AttachmentListItems
                    Attachments={Attachments}
                    OnRemoveAttachment={OnRemoveAttachment}
                />
                <CheckboxFormik
                    Label={strings.Label_Attachments_CopyAttachmentsToCorrespondence}
                    Name={nameof.full<SendEmailExecuteModel<ISendEmailDataModel>>((m) => m.formDataModel.CopyToCorrespondence)}
                    FormikProps={FormikProps}
                />
                <AttachmentListButton
                    type="button"
                    onClick={OnAddAttachment}
                    disabled={attachmentsUploading.length > 0 || attachmentsDeleting.length > 0}
                >
                    {attachmentButtonText()}
                </AttachmentListButton>
            </AttachmentListWrapper>
        );
    }

    return null;
};
